import { appIdReducer } from "./appIdReducer";
import authUserReducer from "./authUserReducer";
import {combineReducers} from 'redux';

const reducers = combineReducers({
    allFiles: appIdReducer,
    authState: authUserReducer
})

export default reducers;